<template>
  <div style="padding: 10px">
    <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border style="margin: 10px 0">
      <template slot-scope="{ row }" slot="name">
        <span style="color:#2d8cf0; cursor: pointer" @click="clicklook(row)">{{ row.name }}</span>
      </template>
    </Table>
    <Page style="text-align: right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
    <Modal v-model="lookShow" @on-cancel="lookShow = false" title="查看">
      <Row style="line-height:4">
        <Col span="24" class="infos">
        <div><img v-if="looksInfo.avatar" :src="path + looksInfo.avatar" alt />
          <img v-else :src="pathimg" alt />
        </div>
        <div style="line-height:2.2">
          <p>姓名：{{ looksInfo.real_name }}</p>
          <p>用户名：{{ looksInfo.name }}</p>
          <p>email：{{ looksInfo.email }}</p>
        </div>
        </Col>
        <Col span="24" v-if="looksInfo.certificate" style="display:flex;align-items: center;margin-top:20px">证件：
        <img class="ceimg" v-for="(item, index) in (looksInfo.certificate).split(',')" :key="index"
          @click="handleView(item)" :src="path + item" alt />
        </Col>
        <Col span="24">个人简介
        <span v-html="looksInfo.instro"></span>
        </Col>
      </Row>
      <div slot="footer">
        <Button type="text" size="small" @click="lookShow = false">取消</Button>
      </div>
    </Modal>
    <Modal title="查看大图" v-model="visible">
      <div style="max-height:70vh;overflow:auto"><img :src="imgName" v-if="visible" style="width: 100%" /></div>
      <div slot="footer">
        <Button type="text" size="small" @click="visible = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage";
  export default {
    data() {
      return {
        visible: false,
        imgName: null,
        searchData: {},
        pathimg: require('@/assets/images/logoname.png'),
        tableColumns: [
          { title: "用户名", slot: "name", align: "center" },
          { title: "姓名", key: "real_name", align: "center" },
          { title: "头衔", key: "curse_title", align: "center" },
          // { title: "所属校区", key: "campus", align: "center" },
          // { title: "个人介绍", slot: "instro", align: "center" },
        ],
        looksInfo: {},
        lookShow: false,
        indexUrl: "/app/teacher/index",
      };
    },
    mixins: [indexPage],
    mounted() { },
    methods: {
      //查看大图
      handleView(name) {
        this.imgName = null
        this.imgName = this.path + name;
        this.visible = true;
      },
      clicklook(row) {
        this.looksInfo = {}
        this.lookShow = true
        var that = this;
        that.$axios.get("/app/teacher/index?id=" + row.id).then((res) => {
          if (res.code == 1) {
            that.looksInfo = res.data;
          } else {
            that.$Message.error(res.msg);
          }
        });
      },
    },
  };
</script>
<style scoped lang='less'>
  .group-name:nth-child(n + 2)::before {
    content: " / ";
  }
  .infos {
    display: flex;
    align-items: center;
    div {
      height: 6vw;
      ;
      overflow: hidden;
      img {
        height: 6vw;
        width: 6vw;
        border-radius: 50%;
        margin-right: 1vh
      }
    }
  }
  .ceimg {
    height: 5vw;
    width: auto;
    margin-right: 1vh
  }
</style>
